import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['container', 'backdrop', 'panel', 'closeButton']
  static classes = ['hidden']

  connect () {
    useClickOutside(this, { element: this.panelTarget })
  }

  show () {
    this.containerTarget.classList.remove('hidden')
    enter(this.backdropTarget)
    enter(this.panelTarget)
    enter(this.closeButtonTarget)
  }

  clickOutside (event) {
    event.preventDefault()
    this.hide()
  }

  hide (event) {
    Promise.all([
      leave(this.backdropTarget),
      leave(this.closeButtonTarget),
      leave(this.panelTarget)
    ]).then(() => {
      this.containerTarget.classList.add('hidden')
    })
  }
}
